import { ICellRendererParams } from "ag-grid-community";
import { useDispatch } from "react-redux";
import {
    updateCustomModal,
    updateProductModalType,
    updateAsinId,
    updateCustomModalTitle,
} from "@features/modalSlice";

const AdGroupAnchorCellRenderer = (params: ICellRendererParams) => {
    const dispatch = useDispatch();
    const modalClickHandler = () => {
        dispatch(updateCustomModal(true));
        dispatch(updateProductModalType("adgroups-modal"));
        dispatch(updateAsinId(params.data.asin));
        dispatch(updateCustomModalTitle(params.data.sku_title));
    };

    return (
        <>
            {params.node.rowPinned ? null : (
                <div className="anchor-class" onClick={modalClickHandler}>
                    {params.data.adgroup_count || 0}
                </div>
            )}
        </>
    );
};

export default AdGroupAnchorCellRenderer;
